var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var SoundOff36 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '36px' : _c, _d = _a.width, width = _d === void 0 ? '36px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 36 36", fill: "none", style: svgStyle },
            React.createElement("circle", { cx: 18, cy: 18, r: 18, fillOpacity: 0.7 }),
            React.createElement("path", { d: "M7.875 13.7392V21.5109H11.3424L18.337 27.2501V8L11.3424 13.7392H7.875Z", fill: "white" }),
            React.createElement("path", { d: "M28.2 14.9113L27.39 14L24.6 17.1387L21.81 14L21 14.9113L23.79 18.05L21 21.1887L21.81 22.1L24.6 18.9613L27.39 22.1L28.2 21.1887L25.41 18.05L28.2 14.9113Z", fill: "white" }))));
};
SoundOff36.displayName = 'SoundOff36';
export default SoundOff36;
//# sourceMappingURL=sound-off-36.js.map